import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
interface DialogData {
    message: string;
    title: string;
}
@Component({
    selector: 'app-infomodal',
    templateUrl: './infomodal.component.html',
    styleUrls: ['./infomodal.component.scss'],
    standalone: false
})
export class InfomodalComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<InfomodalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) { }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
